/* unplugin-vue-components disabled */import script from "./emoji-picker-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./emoji-picker-dialog.vue?vue&type=script&lang=ts&setup=true"

import "./style/index.scss?vue&type=style&index=0&id=e69b1e9a&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e69b1e9a"]])

export default __exports__